import { Row, Skeleton } from '..'
import { cn } from '../..'

interface BannerCarouselLoadingProps {
  className?: string
}

export const BannerCarouselLoading = (props: BannerCarouselLoadingProps) => {
  const { className } = props
  return (
    <div className={cn('relative', className)}>
      <Skeleton className='absolute top-0 left-[11%] w-[78%] h-[123px] mx-auto rounded-md sm:hidden' />
      <Row className={cn('h-[146px] gap-md hidden sm:flex')}>
        <Skeleton className='w-full h-full mx-auto rounded-md' />
        <Skeleton className='w-full h-full mx-auto rounded-md' />
        <Skeleton className='w-full h-full mx-auto rounded-md' />
      </Row>
    </div>
  )
}
